import React from "react";
import Home from "../pages/Home";
import Plugins from "../pages/Plugins";
import Configuration from "../pages/Configuration";
import IrisSettings from "../pages/Iris/Settings";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/admin",
            component: (
                <Home history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/admin/plugins",
            component: (
                <Plugins history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/admin/plugins/:tab",
            component: (
                <Plugins history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/admin/configuration",
            component: (
                <Configuration history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/admin/iris/settings",
            component: (
                <IrisSettings history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/admin/iris/settings/:tab",
            component: (
                <IrisSettings history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        }
    ]
};

export default routes;